import produce from "immer";
import i18n from "i18next";

const defaultState = {
	languages: ['NL','FR','EN'],
	currentLanguage: (i18n.language || 'EN').substr(0, 2).toUpperCase()
};

export default function(state = defaultState, action) {

	switch(action.type) {
		case 'CHANGE_LANGUAGE':
			return produce(state, draft => {
				i18n.changeLanguage(action.language.toLowerCase());
				draft.currentLanguage = action.language.toUpperCase();
			});
		default:
			return state;
	}

}